var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0198 25C10.1325 25 5.33995 20.5125 5.33995 15C5.33995 9.4875 10.1325 5 16.0198 5C21.9071 5 26.6997 9.4875 26.6997 15C26.6997 20.5125 21.9071 25 16.0198 25ZM16.0198 27.5C23.389 27.5 29.3697 21.9 29.3697 15C29.3697 8.1 23.389 2.5 16.0198 2.5C8.65071 2.5 2.66998 8.1 2.66997 15C2.66997 21.9 8.65071 27.5 16.0198 27.5ZM16.0198 11.25L21.3598 16.25L10.6799 16.25L16.0198 11.25Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.f27212aec5a334ab3afca9325590c31e.svg";
export { ForwardRef as ReactComponent };